import { render, staticRenderFns } from "./SealFullscreenTouch.vue?vue&type=template&id=072d74dc&scoped=true"
import script from "./SealFullscreenTouch.vue?vue&type=script&lang=js"
export * from "./SealFullscreenTouch.vue?vue&type=script&lang=js"
import style0 from "./SealFullscreenTouch.vue?vue&type=style&index=0&id=072d74dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d74dc",
  null
  
)

export default component.exports